export const emailRegExp = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/;
export const regexPanNumber = /^([A-Z]{3})?([CPHFATBLJG]{1})?([A-Z]{1})?([0-9]{4})?([A-Z]{1})$/;
export const checkDigit = /^[0-9]+$/;
export const regexName = /^[a-zA-Z ]+$/;
export const ifscRegex = /^[a-zA-Z0-9]+$/;
export const regexSalary = /\(|\)|\d{4}/;
